
import TranResourcesApi from './src/Tranresources'
import SeekHelpApi from './src/seekHelp'


let apis = {
   TranResourcesApi,
   SeekHelpApi
};

export default apis;
